import React from 'react';
import {
  usePlansService
} from 'nekst-api';
import ChoosePlanDropdownWidget from './ChoosePlanDropdownWidget';
import { useNavigate } from 'react-router-dom';

export interface ChoosePlanDropdownProps {
  value?: number;
}

export default function ChoosePlanDropdown(props: ChoosePlanDropdownProps) {
  const plansService = usePlansService();

  const navigate = useNavigate();

  return (
    <ChoosePlanDropdownWidget
      getPlansFunc={async () => plansService.getAllTeamPlans()}
      openListPage={() => {
        navigate('/plans');
      }}
      openPlanPage={(planId: number) => {
        navigate(`/plans/${planId}`);
      }}
      value={props.value}
      showMarketsDropdown
    />
  );
}
